import reducer, { name } from './module';

export * from './module';

export default { name, reducer };
